import React, {
  Fragment,
  FunctionComponent,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import ButtonBar from "../../../../components/Base/ButtonBar";
import Button from "../../../../components/Base/Button";
import { useAuth } from "../../../../hooks/AuthHooks";
import useHookBackendCodeQrPse, {
  TypingOutPeticionGetQr,
  TypingOutUseHookBackend,
} from "../hooks/useHookBackendCodeQrPse";
import SimpleLoading from "../../../../components/Base/SimpleLoading";
import { notifyError, notifyPending } from "../../../../utils/notify";
import { NotifyErrorCustomBase } from "../../../../components/Base/NotifyCustom";
import { useNavigate } from "react-router-dom";
import { sleep } from "../../../../utils/fetchCustomPdp";
import Modal from "../../../../components/Base/Modal";
import ReactToPrint from "react-to-print";
import { PropsComponentQr } from "../utils/utils_typing";

//FRAGMENT ********************* Component *********************************
const WithCodeQrPse = (
  ComponentQr: FunctionComponent<PropsComponentQr>,
  url_backend: string
) => {
  const goNavigate = useNavigate();
  const { commerceInfo, roleInfo }: any = useAuth();
  const [code_qr_url, set_code_qr_url] = useState<string | null>(null);
  const [loadingPeticionInitial, setLoadingPeticionInitial] =
    useState<boolean>(true);
  const [loadingSleep, setLoadingSleep] = useState<boolean>(true);
  const [showModal, setShowModal] = useState<boolean>(true);
  const [loadingPeticion, PeticionGetQr]: TypingOutUseHookBackend =
    useHookBackendCodeQrPse(url_backend);
  const componentRef = useRef<HTMLDivElement | null>(null);
  const botonRef = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    sleep(5)
      .then(() => {
        setLoadingSleep(false);
      })
      .catch(() => {
        setLoadingSleep(false);
      });

    if (loadingSleep) return;
    if (!roleInfo || (roleInfo && Object.keys(roleInfo).length === 0)) {
      setLoadingPeticionInitial(false);
      notifyError(
        "El usuario no cuenta con datos de comercio, por lo que no se permite ingresar a este módulo."
      );
      goNavigate("../info");
      return;
    }
    let hasKeys = true;
    const keys = [
      "id_comercio",
      "id_usuario",
      "tipo_comercio",
      "id_dispositivo",
      "ciudad",
      "direccion",
    ];
    for (const key of keys) {
      if (!(key in roleInfo)) {
        hasKeys = false;
        break;
      }
    }
    if (!hasKeys) {
      setLoadingPeticionInitial(false);
      notifyError(
        "El usuario no cuenta con datos de comercio, por lo que no se permite ingresar a este módulo."
      );
      goNavigate("/");
      return;
    }

    if (!commerceInfo) {
      setLoadingPeticionInitial(false);
      notifyError(
        "El usuario no cuenta con datos de comercio, por lo que no se permite ingresar a este módulo."
      );
      goNavigate("../info");
      return;
    }

    setLoadingPeticionInitial(false);
  }, [
    goNavigate,
    roleInfo,
    loadingSleep,
    loadingPeticionInitial,
    commerceInfo,
  ]);

  const onSubmitGetQr = useCallback(() => {
    notifyPending(
      PeticionGetQr(),
      {
        render: () => {
          return "Procesando";
        },
      },
      {
        render: ({ data }: { data: TypingOutPeticionGetQr }) => {
          set_code_qr_url(data.code_qr_url);
          return "Petición Código QR Exitoso";
        },
      },
      {
        render: ({ data: error }) => {
          goNavigate("../info");
          if (error?.id_any) {
            return NotifyErrorCustomBase(error?.message, error?.id_any);
          }
          return error?.message ?? "Peticiòn Codigo QR Rechazada";
        },
      }
    );
  }, [goNavigate, PeticionGetQr]);

  return (
    <Fragment>
      <Fragment>
        <SimpleLoading
          show={loadingPeticion || loadingPeticionInitial ? true : false}
        />
        <div className="grid grid-flow-row auto-rows-max gap-4 place-items-center text-center">
          <h1 className="text-3xl font-medium">Generación Código QR PSE</h1>
        </div>
        <ButtonBar>
          <Button type="submit" onClick={onSubmitGetQr}>
            Generar y Descargar Código QR PSE
          </Button>
        </ButtonBar>
        {code_qr_url && (
          <Modal
            show={showModal}
            handleClose={() => {
              setShowModal(false);
              goNavigate("../info");
            }}
            bigger={true}
            extraClassName="max-w-4xl"
          >
            <ReactToPrint
              trigger={() => (
                <button ref={botonRef} className="hidden">
                  Imprimir
                </button>
              )}
              content={() => componentRef.current}
              onAfterPrint={() => {
                setShowModal(false);
                goNavigate("../info");
              }}
            />
            <ButtonBar>
              <Button
                onClick={() => {
                  if (botonRef.current) botonRef.current.click();
                }}
              >
                Imprimir o Descargar Código QR PSE
              </Button>
            </ButtonBar>

            <div ref={componentRef}>
              <ComponentQr
                code_qr_url={code_qr_url}
                id_comercio={roleInfo.id_comercio}
              ></ComponentQr>
            </div>
          </Modal>
        )}
      </Fragment>
    </Fragment>
  );
};

export default WithCodeQrPse;
